import { userLeadAssignmentRule } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectIsDomesticUser } from '../selectors';

export const USER_LEAD_ASSIGNMENT_ACTION_TYPE = createNamedActions('userLeadAssigment', {
  GET_LEAD_ASSIGMENT_RULE: 'GET_LEAD_ASSIGMENT_RULE',
  ADD_LEAD_ASSIGMENT_RULE: 'ADD_LEAD_ASSIGMENT_RULE',
  EDIT_LEAD_ASSIGMENT_RULE: 'EDIT_LEAD_ASSIGMENT_RULE',
  DELETE_LEAD_ASSIGMENT_RULE: 'DELETE_LEAD_ASSIGMENT_RULE',
});

export const getLeadRuleAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const isDomesticUser = selectIsDomesticUser(params.companyId)(getState());
  const apiCall = isDomesticUser
    ? userLeadAssignmentRule.getRule
    : userLeadAssignmentRule.getInternalRule;

  const { data } = await apiCall(params);

  return dispatch({
    type: USER_LEAD_ASSIGNMENT_ACTION_TYPE.GET_LEAD_ASSIGMENT_RULE,
    payload: data,
  });
});

export const addLeadRuleAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const isDomesticUser = selectIsDomesticUser(params.companyId)(getState());
  const apiCall = isDomesticUser
    ? userLeadAssignmentRule.createRule
    : userLeadAssignmentRule.createInternalRule;

  const { data } = await apiCall(params);

  return dispatch({
    type: USER_LEAD_ASSIGNMENT_ACTION_TYPE.ADD_LEAD_ASSIGMENT_RULE,
    payload: data,
  });
});

export const editLeadRuleAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const isDomesticUser = selectIsDomesticUser(params.companyId)(getState());
  const apiCall = isDomesticUser
    ? userLeadAssignmentRule.editRule
    : userLeadAssignmentRule.editInternalRule;

  const { data } = await apiCall(params);

  return dispatch({
    type: USER_LEAD_ASSIGNMENT_ACTION_TYPE.EDIT_LEAD_ASSIGMENT_RULE,
    payload: data,
  });
});

export const deleteLeadRuleAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const isDomesticUser = selectIsDomesticUser(params.companyId)(getState());
  const apiCall = isDomesticUser
    ? userLeadAssignmentRule.deleteRule
    : userLeadAssignmentRule.deleteInternalRule;

  await apiCall(params);

  return dispatch({ type: USER_LEAD_ASSIGNMENT_ACTION_TYPE.DELETE_LEAD_ASSIGMENT_RULE });
});
